// extracted by mini-css-extract-plugin
module.exports = {"BooleanFeature":"jx_a"};